import { render, staticRenderFns } from "./goalItem.vue?vue&type=template&id=135c7014&scoped=true"
import script from "./goalItem.vue?vue&type=script&lang=js"
export * from "./goalItem.vue?vue&type=script&lang=js"
import style0 from "./goalItem.vue?vue&type=style&index=0&id=135c7014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c7014",
  null
  
)

export default component.exports